import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

export default {

    async criarHistorico(ordemDeServicoID = ""){

        let historicoOrdemDeServicoItem;

        try{

            //==================================================================//
            //=================== Pega Ordem de Serviço Item ===================//
            //==================================================================//

            let ordemDeServicoItem = await ERP.getOneById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoID);
            if(ordemDeServicoItem.status != 200){
                throw ordemDeServicoItem;
            }

            //==================================================================//
            //============ Prepara Historico X Ordem de Seviço Item ============//
            //==================================================================//

            let historicoOrdemDeServicoItemValores = {
                ordemDeServicoItem: ordemDeServicoItem?.data?.id,
                ...ordemDeServicoItem.data
            };

            delete historicoOrdemDeServicoItemValores.id;

            //==================================================================//
            //============== Cria Historico Ordem de Serviço Item ==============//
            //==================================================================//

            historicoOrdemDeServicoItem = await ERP.postOne(Schema.HISTORICO_ORDEM_DE_SERVICO_ITEM, historicoOrdemDeServicoItemValores);
            if(historicoOrdemDeServicoItem.status != 200){
                throw historicoOrdemDeServicoItem;
            }

            console.log(historicoOrdemDeServicoItem);

            // //==================================================================//
            // //=================== Guarda o Ultimo Historico ====================//
            // //==================================================================//

            // let ordemDeServicoItemValores = {
            //     id: ordemDeServicoID,
            //     ultimoHistorico: historicoOrdemDeServicoItem?.data?.id,
            // }

            // ordemDeServicoItem = await ERP.patchOne(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoItemValores);
            // if(ordemDeServicoItem.status != 200){
            //     throw ordemDeServicoItem;
            // }

        }catch(e){

            console.log(e);
            return historicoOrdemDeServicoItem;

        }

        return historicoOrdemDeServicoItem;

    },

    async criarHistoricos(ordemDeServicoItensIDs = []){

        let historicoOrdemDeServicoItens;

        try{

            //==================================================================//
            //================= Pega Ordens de Serviço Itens ===================//
            //==================================================================//

            let ordemDeServicoItens = await ERP.getManyById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoItensIDs);
            if(ordemDeServicoItens.status != 200){
                throw ordemDeServicoItens;
            }

            //==================================================================//
            //============== Cria Historico Ordem de Seviço Itens ==============//
            //==================================================================//

            let historicoOrdemDeServicoItensValores = ordemDeServicoItens?.data?.map((ordemDeServicoItem)=>{

                let historicoOrdemDeServicoItemValores = {
                    ordemDeServicoItem: ordemDeServicoItem.id,
                    ...ordemDeServicoItem
                }

                delete historicoOrdemDeServicoItemValores.id;

                return historicoOrdemDeServicoItemValores;

            });

            //==================================================================//
            //============== Cria Historico Ordem de Serviço Item ==============//
            //==================================================================//

            historicoOrdemDeServicoItens = await ERP.postMany(Schema.HISTORICO_ORDEM_DE_SERVICO_ITEM, historicoOrdemDeServicoItensValores);
            if(historicoOrdemDeServicoItens.status != 200){
                throw historicoOrdemDeServicoItens;
            }

            console.log(historicoOrdemDeServicoItens);

            // //==================================================================//
            // //=================== Guarda o Ultimo Historico ====================//
            // //==================================================================//

            // let ordemDeServicoItensValores = ordemDeServicoItens?.data?.map((ordemDeServicoItem)=>{

            //     let historicoOrdemDeServicoItem = historicoOrdemDeServicoItens.data.find((historicoOrdemDeServicoItem)=> historicoOrdemDeServicoItem.ordemDeServicoItem == ordemDeServicoItem.id);

            //     return {
            //         id: ordemDeServicoItem.id,
            //         ultimoHistorico: historicoOrdemDeServicoItem?.id
            //     };

            // });

            // let ordensDeServicoItens = await ERP.patchMany(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoItensValores);
            // if(ordensDeServicoItens.status != 200){
            //     throw ordensDeServicoItens;
            // }

        }catch(e){

            console.log(e);
            return historicoOrdemDeServicoItens;

        }

        return historicoOrdemDeServicoItens;

    }

}